<script lang="ts" context="module">
  export const lapsedModal = new ModalQueryState('subscription-lapsed');
</script>

<script lang="ts">
  import Close from '~icons/mdi/close';

  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import { getSubscriptionQuery } from './mutations.svelte';
  import { prettyDate } from '~/utils/dates';
  import ManageSubscription from './ManageSubscription.svelte';

  const subscription = getSubscriptionQuery();

  const handleClose = () => {
    lapsedModal.pop();
  };
</script>

<Modal open={lapsedModal.open} onClose={handleClose} index={7}>
  {#snippet title()}
    <span class="icon">👋</span> Sad to see you leave!
  {/snippet}
  {#snippet content()}
    <p style:text-align="center">
      You have successfully canceled your subscription
    </p>
    {#if subscription.data?.cancel_at}
      <p>
        Your subscription will be available until <b
          >{prettyDate(
            new Date(subscription.data.cancel_at * 1000).toISOString(),
          )}</b
        >
      </p>
    {/if}
    <ManageSubscription />
    <div style:height="1em"></div>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}><Close />Close</ActionButton>
  {/snippet}
</Modal>

<style lang="scss">
  @use '../theme/theme.scss';
  @use 'sass:color';

  .icon {
    font-size: 1.5em;
  }
</style>
